export default __webpack_public_path__ + "static/media/Map.5e93ec88.png";